import React, { FC, useEffect } from "react";
import PetInvoiceCard from "./PetInvoiceCard";
import { useGetPendingInvoiceById } from "../../services/delinquent-payment/delinquent-payment.service";
import { CentralLoadingIndicator } from "..";

interface IPetInvoiceList {
    petId: string;
    petName:string;

  }

const PetInvoiceList: FC<IPetInvoiceList> = ({ petId, petName }) => {
  const { getOverdueInvoices, pendingInvoices, loading } = useGetPendingInvoiceById();

  useEffect(()=>{
    getOverdueInvoices(petId);
  }, []);


  if (loading) {
    return <CentralLoadingIndicator />;
  }

  return (
    <div className="flex flex-col gap-2">
      {pendingInvoices &&
      pendingInvoices.map((invoice, index)=>{
        return <PetInvoiceCard key={index} invoiceData={invoice} petName={petName} />;
      })}
    </div>
  );
};

export default PetInvoiceList;
